import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-tip",
  "use": "icon-icon-tip-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon-tip\"><path d=\"M510.18 91c-232.51 0-421 188.47-421 421s188.49 421 421 421 421-188.51 421-421-188.49-421-421-421z m0 646.42a49 49 0 1 1 49.1-49 49 49 0 0 1-49.1 49z m49.1-212.22a49.1 49.1 0 0 1-98.19 0V296.64a49.1 49.1 0 0 1 98.19 0z\" p-id=\"5753\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol